export { default as BannerSlide } from './BannerSlide';
export { default as UtilLinks } from './UtilLinks';
export { default as Recommended } from './Recommended';
export { default as MostWatched } from './MostWatched';
export { default as Highlights } from './Highlights';


// WEBPACK FOOTER //
// ./src/views/Home/components/index.jsx